var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEachhitterIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.593,
    height: 17.593,
    viewBox: "0 0 17.593 17.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u5BB9",
    "data-name": "\\u5167\\u5BB9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.796,0C3.946,0,0,3.946,0,8.796s3.946,8.796,8.796,8.796,8.796-3.946,8.796-8.796S13.646,0,8.796,0Zm0,1c4.13,0,7.511,3.231,7.771,7.296H1.025C1.285,4.231,4.666,1,8.796,1Zm0,15.593c-4.13,0-7.511-3.231-7.771-7.296h15.542c-.26,4.066-3.641,7.296-7.771,7.296Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEachhitterIcon2);
export default __webpack_public_path__ + "static/media/eachhitter_icon2.eaf721529354a08e8caa19d0e2d720ae.svg";
export { ForwardRef as ReactComponent };